import { render, staticRenderFns } from "./SelectEstaticos.vue?vue&type=template&id=075a4a4a&scoped=true"
import script from "./SelectEstaticos.vue?vue&type=script&lang=js"
export * from "./SelectEstaticos.vue?vue&type=script&lang=js"
import style0 from "./SelectEstaticos.vue?vue&type=style&index=0&id=075a4a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075a4a4a",
  null
  
)

export default component.exports